module.exports = "/cyber/_next/static/images/suggest-result-modal-top-image-de712999fafea015fd926c4927890d85.webp";